import type { GameEvent } from '../game/types';
import type { CombatExchangeModel } from './combat-exchange';
export interface CatalogCard {
  id: string; number: number; name: string; type: string; style: string; rarity: string;
  image: string; text: string; pur?: number; powerLevels?: number[]; level?: number;
}
export interface VisibleCard { id: string; cardId: string; foil: boolean; stage?: number; power?: number; used?: boolean; armed?: boolean; controlling?:boolean; stack?:VisibleCard[] }
export interface VisiblePlayer {
  id: number; character: string; name: string; level: number; stage: number; power: number;
  anger: number; deckCount: number; handCount: number; discard: VisibleCard[]; banished: VisibleCard[];
  board: VisibleCard[]; hand: VisibleCard[]; mp: string; mpFoil?:boolean; controller?:string;
}
export interface BoardModel {
  human: number; players: VisiblePlayer[]; selected: string | null; playable: Set<string>;
  turn: number; phase: string; actor: number; busy: boolean; active: boolean;
  exchange?: CombatExchangeModel | null;
}
export type DisplayEvent = GameEvent;
export interface Preferences { volume: number; voiceVolume?:number; speed: number; reducedMotion: boolean; foil: boolean; fullscreen: boolean }
export const DEFAULT_PREFERENCES: Preferences = { volume: 0.35, voiceVolume:.7, speed: 1, reducedMotion: false, foil: true, fullscreen: false };
